import React, { useEffect, useState } from 'react';
import styles from './login.module.scss';
import {
  IoMail,
  IoLockClosed,
  IoLockOpen,
  IoEyeOffSharp,
  IoEyeSharp
} from 'react-icons/io5';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { Redirect } from 'react-router';
import { ROUTES } from '../../routing/routes';
import { RootState } from '../../redux';
import CInput from '../../components/input/input';
import CButton from '../../components/button/button';
import { useLoginMutation } from '../../api';
import { useHistory } from 'react-router';

const Login = () => {
  const [loginError, setLoginError] = useState('');

  const [form, setForm] = useState({
    email: '',
    password: '',
    canSee: false,
    remember: true
  });

  const [loginUser, loginUserStatus] = useLoginMutation();
  const history = useHistory();
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (loginUserStatus.isSuccess) {
      history.push(ROUTES.HOME);
    }
  }, [loginUserStatus.isSuccess, history]);

  const session = useAppSelector((state: RootState) => state.session.auth);

  const updateForm = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value, name } = event.target;
    setForm(state => ({ ...state, [name]: value }));
  };

  const updateRemember = (checked: boolean) => {
    setForm(state => ({ ...state, remember: checked }));
  };

  const switchS = () => {
    setForm(state => ({ ...state, canSee: !form.canSee }));
  };

  useEffect(() => {
    if (loginUserStatus.error) {
      setLoginError('Email sau parolă greșită');
    }
  }, [loginUserStatus.error, dispatch]);

  const handleSubmit = (event: React.MouseEvent) => {
    /* prevent from reloading */
    event.preventDefault();
    /* submit request */
    // login_req(dispatch);
    /* redirected after request */
    const userPayload = {
      email: form.email,
      password: form.password
    };

    loginUser(userPayload);
  };

  if (session) {
    return <Redirect to={ROUTES.HOME} />;
  }

  return (
    <div className={styles.container}>
      <form>
        <h1>Logare</h1>
        {loginError && <h2>{loginError}</h2>}
        <CInput
          label='Email'
          icon={<IoMail />}
          type='email'
          id='username'
          placeholder='Introduceti email-ul'
          name='email'
          value={form.email}
          onChange={updateForm}
          required
        />
        <CInput
          label='Parola'
          icon={form.canSee ? <IoLockOpen /> : <IoLockClosed />}
          type={form.canSee ? 'text' : 'password'}
          id='password'
          placeholder='si parola'
          name='password'
          value={form.password}
          onChange={updateForm}
          required
          ending={
            <span
              className={form.canSee ? styles.openedEye : styles.closedEye}
              onClick={switchS}
            >
              {form.canSee ? <IoEyeSharp /> : <IoEyeOffSharp />}
            </span>
          }
        />

        {/* <section>
          <label
            htmlFor='remember'
            className={styles.remember}
            onChange={() => updateRemember(!form.remember)}
          >
            <input
              type='checkbox'
              id='remember'
              checked={form.remember}
              onChange={() => updateRemember(!form.remember)}
            />
            Amintește-ți de mine1
          </label>
        </section> */}

        <CButton
          label={'Logare'}
          type='submit'
          onClick={handleSubmit}
          className={styles.loginButton}
        />
        <CButton
          label='Parola uitata?'
          type='submit'
          onClick={() => history.push(ROUTES.FORGOT_PASSWORD)}
          className={styles.resetPassword}
        />
      </form>
    </div>
  );
};

export default Login;
